<template>
  <div id="app" :class="{ bg: isDoctor, bg2: isNotDoctor }">
    <v-app>
      <nav>
        <patient-navigation></patient-navigation>
        <doctor-navigation></doctor-navigation>
        <press-conference-navigation></press-conference-navigation>
      </nav>
      <section>
        <router-view />
        <sponsors-slider></sponsors-slider>
      </section>
      <footer>
        <cookie-law theme="blood-orange" buttonText="Akceptuję">
          <div slot="message">
            Ta strona wykorzystuje pliki cookie.<br />
            Jeśli nie wyrażasz zgody, ustawienia dotyczące plików cookies możesz
            zmienić w&nbsp;swojej przeglądarce.
          </div>
        </cookie-law>
      </footer>
    </v-app>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import { setCookie, storeSession } from "@/services/Cookies";
import SponsorsSlider from "@/components/partials/SponsorsSlider";
import PatientNavigation from "@/components/partials/PatientNavigation";
import DoctorNavigation from "@/components/partials/DoctorNavigation";
import PressConferenceNavigation from "@/components/partials/PressConferenceNavigation";

export default {
  name: "App",
  data() {
    return {
      nAgt: navigator.userAgent,
      homepageBg: "/static/images/bg-main.jpg?v=1",
      doctorBg: "/static/images/register-bg.png",
      isDoctor: true,
      isNotDoctor: false,
      dataBrowser: [
        {
          string: navigator.userAgent,
          subString: "facebookexternalhit/",
          identity: "Facebook Bot",
        },
        {
          string: navigator.vendor,
          subString: "facebookexternalhit/",
          identity: "Facebook Bot",
          versionSearch: "Version",
        },
        {
          string: navigator.userAgent,
          subString: "Googlebot",
          identity: "Googlebot",
        },
        {
          string: navigator.vendor,
          subString: "Googlebot/",
          identity: "Googlebot",
          versionSearch: "Version",
        },
        {
          string: navigator.userAgent,
          subString: "Edge",
          identity: "Edge",
        },
        {
          string: navigator.userAgent,
          subString: "EdgA",
          identity: "Edge",
        },
        {
          string: navigator.userAgent,
          subString: " OPR/",
          identity: "Opera",
        },
        {
          string: navigator.userAgent,
          subString: "Opera",
          identity: "Opera",
        },
        {
          string: navigator.userAgent,
          subString: "SamsungBrowser/",
          identity: "Samsung Browser",
        },
        {
          string: navigator.userAgent,
          subString: "Chrome",
          identity: "Chrome",
        },
        {
          string: navigator.userAgent,
          subString: "FBAN",
          identity: "Facebook App",
        },
        {
          string: navigator.userAgent,
          subString: "FBAV",
          identity: "Facebook App",
        },
        {
          string: navigator.userAgent,
          subString: "OmniWeb",
          versionSearch: "OmniWeb/",
          identity: "OmniWeb",
        },
        {
          string: navigator.vendor,
          subString: "Apple",
          identity: "Safari",
          versionSearch: "Version",
        },
        {
          prop: window.opera,
          identity: "Opera",
          versionSearch: "Version",
        },
        {
          prop: window.opera,
          identity: " OPR/",
          versionSearch: "Version",
        },
        {
          string: navigator.userAgent,
          subString: "Opera Mini/",
          identity: "Opera Mini",
        },
        {
          string: navigator.userAgent,
          subString: "Presto/",
          identity: "Opera Mini",
        },
        {
          string: navigator.userAgent,
          subString: " Coast/",
          identity: "Opera",
        },
        {
          string: navigator.vendor,
          subString: "iCab",
          identity: "iCab",
        },
        {
          string: navigator.vendor,
          subString: "FBAN",
          identity: "Facebook App",
        },
        {
          string: navigator.vendor,
          subString: "FBAV",
          identity: "Facebook App",
        },
        {
          string: navigator.vendor,
          subString: "KDE",
          identity: "Konqueror",
        },
        {
          string: navigator.userAgent,
          subString: "Firefox",
          identity: "Firefox",
        },
        {
          string: navigator.vendor,
          subString: "Camino",
          identity: "Camino",
        },
        {
          // for newer Netscapes (6+)
          string: navigator.userAgent,
          subString: "Netscape",
          identity: "Netscape",
        },
        {
          string: navigator.userAgent,
          subString: "MSIE",
          identity: "Internet Explorer",
          versionSearch: "MSIE",
        },
        {
          string: navigator.userAgent,
          subString: "Trident",
          identity: "Internet Explorer",
          versionSearch: "Trident",
        },
        {
          string: navigator.userAgent,
          subString: "Gecko",
          identity: "Mozilla",
          versionSearch: "rv",
        },
        {
          // for older Netscapes (4-)
          string: navigator.userAgent,
          subString: "Mozilla",
          identity: "Netscape",
          versionSearch: "Mozilla",
        },
      ],
      dataOS: [
        {
          string: navigator.platform,
          subString: "Win",
          identity: "Windows",
        },
        {
          string: navigator.platform,
          subString: "Mac",
          identity: "Mac",
        },
        {
          string: navigator.userAgent,
          subString: "iPhone",
          identity: "iPhone/iPod",
        },
        {
          string: navigator.userAgent,
          subString: "iPad",
          identity: "iPad",
        },
        {
          string: navigator.userAgent,
          subString: "Linux; Android",
          identity: "Android",
        },
        {
          string: navigator.platform,
          subString: "Linux",
          identity: "Linux",
        },
      ],
    };
  },
  components: {
    SponsorsSlider,
    CookieLaw,
    PatientNavigation,
    DoctorNavigation,
    PressConferenceNavigation,
  },
  mounted() {
    if (window.localStorage.getItem("wgwtoken")) {
      this.storeSesion();
    } else {
      let token =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      window.localStorage.setItem("wgwtoken", token);
      setCookie({ token }).then(this.storeSesion());
    }
    this.isDoctor = true;
  },
  methods: {
    initBrowser() {
      return (this.browser =
        this.searchString(this.dataBrowser) || "An unknown browser");
    },
    initVersion() {
      return (this.version =
        this.searchVersion(navigator.userAgent) ||
        this.searchVersion(navigator.appVersion) ||
        "an unknown version");
    },
    initOS() {
      return (this.OS = this.searchString(this.dataOS) || "an unknown OS");
    },
    searchString(data) {
      for (var i = 0; i < data.length; i++) {
        var dataString = data[i].string;
        var dataProp = data[i].prop;
        this.versionSearchString = data[i].versionSearch || data[i].identity;
        if (dataString) {
          if (dataString.indexOf(data[i].subString) != -1)
            return data[i].identity;
        } else if (dataProp) return data[i].identity;
      }
    },
    searchVersion(dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index == -1) return;
      return parseFloat(
        dataString.substring(index + this.versionSearchString.length + 1)
      );
    },
    storeSesion() {
      let nameOffset;
      let verOffset;
      let ix;
      let fullVersion = "" + parseFloat(navigator.appVersion);
      let majorVersion = parseInt(navigator.appVersion, 10);
      var browser = this.initBrowser();

      var token = window.localStorage.getItem("wgwtoken");
      var version = this.initVersion();
      var agent = navigator.userAgent;
      var os = this.initOS();
      var resolution = window.innerWidth + "x" + window.innerHeight;
      var ip = this.ip;

      storeSession({ token, browser, version, agent, os, resolution, ip });
    },
  },
  watch: {
    $route: function () {
      if (this.$route.name === "Doctors") {
        this.isDoctor = false;
        this.isNotDoctor = true;
      } else {
        this.isDoctor = true;
        this.isNotDoctor = false;
      }
    },
  },
};
</script>

<style lang="stylus">
@import './stylus/main';

.bg .application {
  position: relative;
}

:root {
  --bg: $mainBg;
}

.bg .application:before {
  content: '';
  width: 100%;
  height: 100%;
  position: fixed;
  background-image: url('/static/images/bg-main-2026.png');
  background-repeat: no-repeat;
  background-position: center revert;
}

.bg2 .application:before {
  content: '';
  width: 100%;
  height: 100%;
  position: fixed;
  background-image: url('/static/images/register-bg.png');
  background-repeat: no-repeat;
  background-position: center;
}

#app .application {
  font-family: 'Fira Sans', sans-serif !important;
}

.v-text-field .v-input__slot {
  border: 1px solid #275271;
}

.v-textarea .v-input__slot {
  border: 1px solid #275271;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-form>.container>.layout>.flex {
  padding-bottom: 0px !important;
}

.register-form--spacing textarea {
  margin-top: 8px !important;
}

.cssmap .active-region .bg {
  z-index: 1 !important;
}

.Cookie--blood-orange .Cookie__button {
  background: rgba(164, 22, 17, 0.9) !important;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/App.vue